import { removeFrontZero as removeFrontZeroFunction, formatPhone } from "@/utils/string";
import { formatChatDate, formatTalkDate } from "@/utils/date";

/**
 * 删除前置零符号
 */
const removeFrontZero = str => {
	return removeFrontZeroFunction(str);
};

/**
 * 对话时间格式
 */
const conversationDateFormat = date => {
	if (date === null) {
		return "";
	}

	return formatChatDate(date);
};

/**
 * 消息时间格式
 */
const messageDateFormat = date => {
	if (date === null) {
		return "";
	}

	return formatTalkDate(date);
};

export default {
	install(Vue) {
		Vue.filter("removeFrontZero", removeFrontZero);
		Vue.filter("conversationDateFormat", conversationDateFormat);
		Vue.filter("messageDateFormat", messageDateFormat);
		Vue.filter("formatPhone", formatPhone);
	}
};
